import {apiClient} from "../utils/Api";

export default class UserCarService {

    static create = (data) => {
        return apiClient.post(`/user-car/create`, data);
    };

    static update = (data) => {
        return apiClient.post(`/user-car/update`, data);
    };

    static updateInfo = (data) => {
        return apiClient.post(`/user-car/update-info`, data);
    };

    static uploadImg = (data) => {
        console.log(data);
        return apiClient.post(`/user-car/updateCarImg`, data);
    };

    static detail = (id) => {
        return apiClient.get('/user-car/detail?id='+id);
    }

    static list = () => {
        return apiClient.get('/user-car/list');
    }
}